export default __webpack_public_path__ + "static/media/office_desk_logo_backup.b5c8696a.png";